import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';
import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry, } from 'ag-grid-community';
import { AllEnterpriseModule, } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  AllCommunityModule,
]);

console.log('Version', environment.version);

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: "https://d307ccf55cc6b807d67c32985d42b279@o4507463676264448.ingest.de.sentry.io/4507464651767888",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.replayIntegration({ maskAllText: false }),
    ],
    environment: environment.production ? 'Production' : 'Development',
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [environment.api_url],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    release: environment.version
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, { preserveWhitespaces: false })
  .catch(err => console.error(err));
